import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { TableContentSupplierDairySummaryReport } from "../../../Common/Table/tableContent";
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { supplierDairySummaryReportSchema } from "../supplierDairySummaryReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import TablePagination from '@material-ui/core/TablePagination';
import Chip from '@material-ui/core/Chip';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MaterialTable, { MTableBody } from "material-table";
import _, { flatMap } from 'lodash';
import $ from 'jquery';

const screenCode = 'SUPPLIERDAIRYSUMMARYREPORT'

export function SupplierDairySummaryReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [collectionCategory, setCollectionCategory] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        date: ""
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(supplierDairySummaryReportSchema).options({ allowUnknown: true });
    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [reportData, setReportData] = useState([]);
    const [isViewTable, setIsViewTable] = useState(true);
    const [columeNames, setColumeNames] = useState([]);
    const [allTotal, setAllTotal] = useState([]);
    const [total, setTotal] = useState(0);
    const [grossTotal, setGrossTotal] = useState([]);
    const [csvTotalRow, setCsvTotalRow] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const initialContentRowNames = ["welfareSociety", "supplierName", "regNo", "grossAmount"];
    const [contentRowNames, setContentRowNames] = useState([]);
    const [csvHeaders, setCsvHeaders] = useState([]);
    const initalCsvHeaders = [
        { label: "welfare Society", value: "welfareSociety" },
        { label: "Supplier Name", value: "supplierName" },
        { label: "Supplier Reg No", value: "regNo" },
        { label: "Weight", value: "grossAmount" },
    ];
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        collectionID: "",
        date: "",
    });

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown()
        )
        checkDisbursement();
    }, [searchData.operationEntityID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSUPPLIERDIARYSUMMARYREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, supplierDairySummaryReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }
    async function handleSearch(e) {

        setIsTableHide(true);
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        setIsViewTable(true);
        const reportData = await service.GetSupplierDairySummaryReport(searchData.operationEntityID, searchData.collectionPointID, searchData.date);

        setSelectedSearchData();
        calTotalVloume(reportData)

        var totRecord = {
            welfareSociety: "Total",
        };

        reportData.forEach((x, i) => {
            for (const item in x) {
                if ((item) !== "welfareSociety" && (item) !== "regNo" && (item) !== "supplierName") {
                    totRecord[item] = (totRecord[item] === undefined ? 0 : parseFloat(totRecord[item])) + parseFloat(x[item]);
                }
            }
        });
        setCsvTotalRow(totRecord);

        if (reportData.length > 0) {
            setIsTableHide(false);
            setReportData(reportData);
            createDataTable();
        }

    }
    async function calTotalVloume(data) {
        if (data != null || data != undefined) {
            const grossTotal = data.reduce((previousScore, currentScore, index) => previousScore + currentScore.grossAmount, 0);
            setGrossTotal(grossTotal);
        }
    }

    function destroyDataTable() {
        $("#reportTable").DataTable().destroy();
    }

    function createDataTable() {
        $("#reportTable").DataTable({
            scrollX: true
        });
    }

    function checkUndifined(value) {
        if (value === undefined || value === NaN || value === "-") {
            return 0;
        } else {
            return value;
        }
    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: operationEntity[searchData.operationEntityID],
            collectionID: collectionPoint[searchData.collectionPointID],
            date: searchData.date
        })
    }

    function checkDisbursement() {
        if (searchData.month === '') {
            setIsViewTable(true);
        }
        else {
            setIsViewTable(false);
        }
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function createFile() {
        var settings = {
            sheetName: 'Supplier Dairy Summary Report',
            fileName: 'SupplierDairySummaryReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(reportData)
        copyOfCsv.push(csvTotalRow)

        copyOfCsv.push({}, {
            welfareSociety: "Group: " + selectedSearchValues.group,
            supplierName: "Factory: " + selectedSearchValues.estate,
            regNo: "Current Date: " + new Date().toLocaleString()
        });
        var copyOfCsv1 = _.cloneDeep(copyOfCsv)
        copyOfCsv1.push({
            welfareSociety: "User: " + tokenService.getUserNameFromToken(),
            supplierName: "Date: " + selectedSearchValues.date
        });

        xlsx(initalCsvHeaders, copyOfCsv1, settings, true)
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Supplier Dairy Summary Report"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Factory *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Factory--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Collection point</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <TextField
                                        id="date"
                                        label="Date *"
                                        name="date"
                                        type="date"
                                        fullWidth
                                        value={searchData.month}
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["date"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["date"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                            {isTableHide ? null :
                                <Grid item md={12} xs={12}>
                                    <table id="reportTable">
                                        <thead>
                                            <tr>
                                                <th rowSpan="2">Welfare Society</th>
                                                <th rowSpan="2">Supplier Name</th>
                                                <th rowSpan="2">Supplier Reg No</th>
                                                <th rowSpan="2">Weight</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <TableContentSupplierDairySummaryReport
                                                data={reportData}
                                                contentRowNames={initialContentRowNames}
                                                hasEdit={false}
                                            />
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th colSpan="1">Total</th>
                                                <th></th>
                                                <th></th>
                                                <th style={{ textAlign: "right" }}>{grossTotal.toFixed(2)}</th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </Grid>
                            }
                        </form>
                        {
                            (reportData.length == 0 || reportData == undefined || reportData == null || reportData == []) ?
                                null : <div className="pt-3">
                                    <ReactToPrint
                                        trigger={() => <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Create PDF"
                                        />}
                                        content={() => componentRef.current}
                                        documentTitle={'Total Crop Report'}
                                    />
                                    <div hidden={true}>
                                        <CreatePDF ref={componentRef} data={reportData} rowNames={initialContentRowNames}
                                            searchData={selectedSearchValues} totalRow={grossTotal} columeNames={columeNames} />
                                    </div>
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



